import * as Fetch from '@/helpers/fetch'

export const getBannersList = async (token: string): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_SERVICE_URL}/v1/banners`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}